<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="queryEvalProjectForm"
        :model="queryEvalProjectForm"
        label-width="80px"
      >
        <el-row :gutter="20">
           <el-col :span="6">
            <el-form-item label="所属分类">
              <el-select
                clearable
                v-model="queryEvalProjectForm.categoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目分类">
              <el-select
                v-model="queryEvalProjectForm.typeKey"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in evaluateTypeArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" @click="getEvalProjectList"
              >查询</el-button
            >
            <el-button type="primary" @click="addCtiy">创建</el-button>
             <el-button type="primary" @click="exportExcelData">批量导出</el-button>
            <el-upload
                      style="display:inline"
                      action="aa"
                      :show-file-list="false"
                      :before-upload="importSendInfo">
                <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
            <a style="marginLeft:20px;" type="primary"  @click="getEvaluationItemsTemplete" >导入模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="name" label="评估项目"> </el-table-column>
        <el-table-column
          prop="multipleChoice"
          :formatter="choiceFormatter"
          label="单选/多选"
        >
        </el-table-column>
        <el-table-column prop="linkTypeName" label="项目分类">
        </el-table-column>
        <el-table-column prop="brandName" label="所属分类"> </el-table-column>
        <el-table-column prop="status" label="前端展示">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">展示</span>
            <span v-else>不展示</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="editEvalProject(scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >展示</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不展示</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index - 1)"
              type="text"
              size="small"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index + 1)"
              type="text"
              size="small"
              v-if="scope.$index < tableData.length - 1"
              >下移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, 0, true)"
              type="text"
              size="small"
              >置顶</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, -1, true)"
              type="text"
              size="small"
              >置底</el-button
            >
            <el-button @click="deleteLinkage(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑评估项目' : '新建评估项目'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editEvalProjectForm"
            :model="editEvalProjectForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editEvalProjectForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属分类" prop="parentId">
              <el-select
                clearable
                v-model="editEvalProjectForm.parentId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目分类" prop="typeKey">
              <el-select
                clearable
                v-model="editEvalProjectForm.typeKey"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in evaluateTypeArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="评估项目" prop="name">
              <el-input clearable v-model="editEvalProjectForm.name"></el-input>
            </el-form-item>
            <el-form-item label="单选/多选" prop="multipleChoice">
              <el-select
                clearable
                v-model="editEvalProjectForm.multipleChoice"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in this.global.multipleChoiceType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      evaluateTypeArray: this.global.evaluateType,
      // 查询数据
      queryEvalProjectForm: {
        typeKey: null,
        categoryId:null
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据
      isDlg: false,
      editEvalProjectForm: {
        id: null,
        value: null,
        name: null,
        multipleChoice: "",
        typeKey: "",
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入评估项目", trigger: "change" },
        ],
        parentId: [
          { required: true, message: "请输入所属分类", trigger: "change" },
        ],
        multipleChoice: [
          { required: true, message: "请选择单选/多选", trigger: "change" },
        ],
        typeKey: [
          { required: true, message: "请选择项目分类", trigger: "change" },
        ],
      },

      dlgType: "change",

      loading: false,

      categoryOptions: [],
      fullscreenLoading:false
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteLinkage(id){
      let self = this
      self.$confirm('是否删除').then(() => {
          self.$api.deleteLinkage({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getEvalProjectList()
          }
      })
      })
    
    },
       // click事件
    exportExcelData () {
      let self = this
      self.$api
        .getClass({
          typeKey: self.queryEvalProjectForm.typeKey ||"evaluate_condition,evaluate_function",
          brandId: self.queryEvalProjectForm.categoryId ||null,
          page: 1,
          size: self.tableTotal,
        })
        .then((res) => {
          var downLoadTableData = res.data.records || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName = ["编号", "评估项目","单选/多选","项目分类","所属分类"];
                const filterVal = ["value", "name", "multipleChoice", "linkTypeName", "brandName"];
                const data = downLoadTableData.map(v => filterVal.map(j => {
                        if(j=="multipleChoice"){
                          return v[j]==1?"单选":"多选"
                        }else{
                          return v[j]
                        }    
                }
                 ));
                export_json_to_excel(fieldName, data, "评估项目"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
        });
    },
     // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()

      formData.append('file', file)
      this.$api.imporEvaluationItemsTemplete(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getEvalProjectList()
        }
      })
      return false;
    },
    getEvaluationItemsTemplete(){
      window.open(`${location.origin}/api/sys/linkage/getEvaluationItemsTemplete`)
    },
    choiceFormatter(row) {
      switch (row.multipleChoice) {
        case 1:
          return "单选";
        case 2:
          return "多选";
        default:
          return "其他";
      }
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getEvalProjectList();
    },

    // 获取表格数据
    getEvalProjectList() {
      let self = this;
      self.$api
        .getClass({
          typeKey: self.queryEvalProjectForm.typeKey ||"evaluate_condition,evaluate_function",
          brandId: self.queryEvalProjectForm.categoryId ||null,
          page: self.currentPage,
          size: self.pageSize,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addCtiy() {
      this.dlgType = "new";
      this.editEvalProjectForm = {};
      this.$nextTick(()=>{
          this.$refs['editEvalProjectForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editEvalProject(row) {
      let self = this;
      self.editEvalProjectForm = {};
      self.dlgType = "change";
      self.editEvalProjectForm = row;
      self.isDlg = true;
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editEvalProjectForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.editEvalProjectForm) {
            params[i] = this.editEvalProjectForm[i];
          }
          if (self.dlgType === "change") {
            self.$api.changeLinkage(params.id, params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                self.getEvalProjectList();
                self.closeEditormodelDlg();
              }
            });
          } else {
            self.$api.addLinkage(params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                self.getEvalProjectList();
                self.closeEditormodelDlg();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      self.$api
        .changeLinkage(row.id, {
          name: row.name,
          status: newStatus,
          typeKey: row.typeKey,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            self.getEvalProjectList();
          }
        });
    },
    getCategory() {
      let self = this;
      self.$api
        .getClass({
          typeKey: "category",
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          self.categoryOptions = res.data.records || [];
        });
    },

    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api
        .changeLinkageOrder({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getEvalProjectList();
          }
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getEvalProjectList();
    self.getCategory();
  },
};
</script>
<style lang="less" scoped></style>
